import React from 'react'
import { Stack, Typography, Button } from '@mui/material'
import { AddOutlined } from '@mui/icons-material'

import { useNavigate } from 'react-router-dom'

export const CreditCardsTabHeader: React.FC = () => {
  const navigate = useNavigate()

  const handleAddCard = () => {
    navigate('/card/add')
  }

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Typography variant="h6" fontWeight="bold">
        Meus cartões
      </Typography>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddOutlined />}
        onClick={handleAddCard}
        disableElevation
        sx={{ borderRadius: 4 }}
      >
        Adicionar
      </Button>
    </Stack>
  )
}
